module.exports = __webpack_public_path__ + "img/video_fill.e7c46fad.svg";